import React from 'react';
import '../styles/IntroPage.css';  // Import styles
import { FaUser } from 'react-icons/fa';
import Logo from './Logo.jsx';
import { useT } from '../contexts/LocaleContext.jsx';
import { richMessage } from '../_helpers/richMessage.jsx';

function IntroPage({ onLoginClick }) {
  const t = useT();

  return (
    <div className="intro-page">
        <div className="intro-page-container">
          <Logo />

          {/* The tagline is one message so a translator can reorder it; the two
              phrases are separate animation targets and the punctuation between
              and after them fades in with the second. */}
          <span className="slogan">{t('intro.slogan.headline')}<br />
            {richMessage(
              t('intro.slogan.tagline'),
              {
                yourSong: <span className='fade1'>{t('intro.slogan.yourSong')}</span>,
                yourStage: <span className='fade2'>{t('intro.slogan.yourStage')}</span>,
              },
              { text: (chunk) => <span className='fade2'>{chunk}</span> }
            )}
          </span>

          <div className="world-stage-container">
            <img src="/assets/images/WorldStage-nobg.png" alt={t('intro.worldStageAlt')} className="world-stage-image" />
          </div>

          <div>
            <button className="login-button" onClick={onLoginClick}>
              <div className="login-button-container">
                <span className="login-icon-container">
                  <FaUser className="login-icon" />
                </span>
                <span className="login-text">{t('intro.loginButton')}</span>
              </div>
            </button>
          </div>
        </div>

    </div>
  );
}

export default IntroPage;
